export default "__VITE_ASSET__BuGutImE__"